import React, { useEffect, useCallback, useState } from "react";
import { Link } from "react-router-dom";

import ScrollTop from "../../../common/scrolltop/scrolltop";
import styles from "./blog.module.css";
import header from "../../header/header.module.css";
import { article } from "../../../common/article/article";
import { keyword } from "../../../common/article/keyword";
import arrow from "../../../image/svgicon/dropdown.svg";
import blogImg from "../../../image/blog/blog.2denoise.png";
import getGA from "../../../service/ga.js";
import { Helmet } from "react-helmet-async";
import favicon from "../../../image/img_mondayoff_s.png";
const Blog = (props) => {
  useEffect(() => {
    getGA();
  }, []);
  const [select, setSelect] = useState({
    id: 1,
    key: "All",
  });
  const [getArticle, setGetArticle] = useState([]);

  useEffect(() => {
    if (select.key === "All") {
      setGetArticle(article);
    } else {
      const findByTag = article.filter((data) => select.key === data.tag);
      setGetArticle(findByTag);
    }
  }, [select]);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const handleWindowsize = useCallback(() => {
    setWindowSize(window.innerWidth);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleWindowsize);
    return () => {
      window.removeEventListener("resize", handleWindowsize);
    };
  });
  useEffect(() => {
    const menulist = document.getElementsByClassName(header.menulist);
    const logoImg = document.getElementsByClassName(header.logo);
    menulist[0].classList.remove(header.active);
    logoImg[0].classList.remove(header.active);
  }, []);
  useEffect(() => {
    const nav = document.getElementsByClassName(header.nav);
    const gameMenu = document.getElementsByClassName(header.gamemenu);
    const gameText = document.getElementsByClassName(header.gametext);
    const publishPage = document.getElementsByClassName(header.publishmenu);
    const publishText = document.getElementsByClassName(header.publishtext);
    const partnershipPage = document.getElementsByClassName(
      header.partnershipmenu
    );
    const partnershipText = document.getElementsByClassName(
      header.partnershiptext
    );
    const articleMenu = document.getElementsByClassName(header.articlemenu);
    const articleText = document.getElementsByClassName(header.articletext);
    if (props.match.path === "/blog") {
      if (windowSize < 769) {
        nav[0].style.position = "sticky";
        gameMenu[0].style.borderBottom = "";
        gameText[0].style.fontWeight = "";
        gameText[0].style.color = "";
        publishPage[0].style.borderBottom = "";
        publishText[0].style.fontWeight = "";
        publishText[0].style.color = "";
        partnershipPage[0].style.borderBottom = "";
        partnershipText[0].style.fontWeight = "";
        partnershipText[0].style.color = "";
        articleMenu[0].style.borderBottom = "";
        articleText[0].style.fontWeight = 700;
        articleText[0].style.color = "#ffff";
      } else {
        nav[0].style.position = "sticky";
        gameMenu[0].style.borderBottom = "";
        gameText[0].style.fontWeight = "";
        publishPage[0].style.borderBottom = "";
        publishText[0].style.fontWeight = "";
        partnershipPage[0].style.borderBottom = "";
        partnershipText[0].style.fontWeight = "";
        articleMenu[0].style.borderBottom = "5px solid #ffff";
        articleText[0].style.fontWeight = 700;
      }
    }
  }, [props.match.path, windowSize]);
  const onClick = () => {
    window.scrollTo(0, 0);
  };

  const isSelected = (item) => {
    return select?.id === item.id;
  };

  const dropDownList = document.getElementsByClassName(styles.listcontainer);
  const onClickDropDown = () => {
    dropDownList[0].classList.toggle(styles.active);
  };

  return (
    <>
      <ScrollTop />
      <Helmet>
        <title>MondayOFF - Blog</title>
        <link rel="icon" href={favicon} data-react-helmet="true" />
        <meta
          name="description"
          content="MondayOFF - Blog"
          data-react-helmet="true"
        />
        <meta property="og:type" content="website" data-react-helmet="true" />
        <meta
          property="og:site_name"
          content="MondayOFF - Blog"
          data-react-helmet="true"
        />
        <meta
          property="og:title"
          content="MondayOFF - Blog"
          data-react-helmet="true"
        />
        <meta
          property="og:description"
          content="MondayOFF - Blog"
          data-react-helmet="true"
        />
        <meta
          property="og:image"
          content="https://www.mondayoff.me/mondayoff_logo_profile.jpg"
        />
        <meta
          property="og:url"
          content="https://www.mondayoff.me/blog"
          data-react-helmet="true"
        />
        <meta
          property="twitter:card"
          content="summary"
          data-react-helmet="true"
        />
        <meta
          property="twitter:title"
          content="MondayOFF - Blog"
          data-react-helmet="true"
        />
        <meta
          property="twitter:url"
          content="https://www.mondayoff.me/blog"
          data-react-helmet="true"
        />
        <meta
          property="twitter:image"
          content="https://www.mondayoff.me/mondayoff_logo_profile.jpg"
          data-react-helmet="true"
        />
        <meta
          property="twitter:description"
          content="MondayOFF - Blog"
          data-react-helmet="true"
        />
      </Helmet>
      <div className={styles.button} onClick={onClick}>
        <div className={styles.toparrow}>⌃</div>
      </div>
      <div className={styles.containter}>
        <div className={styles.background}>
          <div className={styles.toptext}>
            <h1>Explore and Discover</h1>
            <p className={styles.firstliterature}>
              All the industry insights you must know right here!
            </p>
            <p className={styles.secondliterature}>
              Stay up to date with everything Hypercasual from advice for
              developers to trend analysis, and much more.
            </p>
          </div>
          <div className={styles.circle1}></div>
          <div className={styles.circle2}></div>
          <div className={styles.circle3}></div>
          <img src={blogImg} alt="background" className={styles.topImg} />
        </div>

        <div className={styles.contentscontainer}>
          <ul className={styles.sidebar}>
            <span>Blog.</span>
            <button className={styles.dropdown} onClick={onClickDropDown}>
              {select.key}
              <object
                type="image/svg+xml"
                data={arrow}
                className={styles.arrow}
              >
                arrow
              </object>
            </button>
            <div className={styles.listcontainer}>
              {keyword.map((data) => (
                <li
                  className={styles.list}
                  key={data.id}
                  onClick={() => {
                    setSelect(data);
                    dropDownList[0].classList.remove(styles.active);
                  }}
                  style={{
                    color: isSelected(data) ? "#F02E2E" : "#333335",
                  }}
                >
                  {data.key}
                </li>
              ))}
            </div>
          </ul>

          {getArticle.length > 0 ? (
            <div className={styles.cardcontainer}>
              {getArticle.map((data) => {
                let scriptTag = data?.tag?.replace(/ /g, "");
                return (
                  <Link
                    to={`/${scriptTag}/${data.id}`}
                    key={data.id}
                    match={data.id}
                  >
                    <div className={styles.card}>
                      <div>
                        <img
                          src={data.topImg ? data.topImg : data.img}
                          alt=""
                        />
                      </div>
                      <div className={styles.tag}>{data.tag}</div>
                      <div className={styles.title}>{data.title}</div>
                      <div className={styles.context}>{data.context}</div>
                    </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className={styles.notfound}>
              <p>Coming Soon</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Blog;
